import Drawer from '@mui/material/Drawer';
import type { HtmlElementProps } from '@/types';
import { classes, styles } from './utils';

export interface OverlayProps extends HtmlElementProps {
  variant?: 'default' | 'glass';
  onClose: () => void;
}

export default function Overlay({
  variant = 'default',
  onClose,
  ...props
}: OverlayProps) {
  const isGlass = variant === 'glass';
  return (
    <Drawer
      open
      sx={isGlass ? styles.glassDrawer : styles.drawer}
      anchor="left"
      PaperProps={{
        className: isGlass ? undefined : classes.paper,
      }}
      slotProps={{
        backdrop: { sx: isGlass ? styles.glassBackdrop : styles.backdrop },
      }}
      onClose={onClose}>
      <div {...props} />
    </Drawer>
  );
}
